import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../shared/service/data.service';
import {
  PvoKafInter,
  FieldData,
  Chart,
} from '../../../shared/interface/field.interface';
import * as XLSX from 'xlsx';
import * as chartData from '../../../shared/data/chart';
import { trigger, style, animate, transition } from '@angular/animations';
import { environment } from 'src/environments/environment.prod';
import { LocalDataSource } from 'ng2-smart-table';
interface tmp {
  tableLoading: boolean;
  kafName: string;
}
@Component({
  selector: 'app-by-indicator',
  templateUrl: './by-indicator.component.html',
  styleUrls: ['./by-indicator.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate('500ms', style({ transform: 'translateX(100%)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class ByIndicatorComponent implements OnInit {
  tizim;
  tmp: tmp = {
    tableLoading: true,
    kafName: '',
  };
  calCitiation: any = {
    current: 100,
    maxGrade: environment.otm === 'fstu' ? 5 : 9,
    // title: ''
  };
  calCitiation1d5d2: any = {
    current: 25,
    maxGrade: 25,
  };
  field;
  pvoKaf: PvoKafInter[];
  kafedra = [];
  fakultet = [];
  showKbi: boolean = false;
  selectedLabel = '1.1';

  public kafedraSet = {
    hideSubHeader: true,
    pager: {
      display: true,
    },
    actions: {
      add: false,
      edit: false,
      delete: false,
      position: 'none',
    },
    columns: {},
  };
  public fakultetSet = {
    hideSubHeader: true,
    pager: {
      display: true,
    },
    actions: {
      add: false,
      edit: false,
      delete: false,
      position: 'none',
    },

    columns: {},
  };
  public settings = {
    pager: {
      display: true,
    },
    actions: {
      add: false,
      edit: false,
      delete: false,
      position: 'none',
    },
    rowClassFunction: (row) => {
      if (environment.otm === 'fjsti') {
        let { wagerate, all } = row.data;
        wagerate = parseFloat(wagerate);
        all = parseFloat(all);
        if (
          this.isGradeEnough(wagerate, all)
        ) return 'red-row';
        return '';
      }
    },
    columns: {},
  };
  source = new LocalDataSource();
  labels: any[] = [];
  chartFakul: Chart = {
    type: 'Line',
    data: {
      labels: environment.fakultet,
      series: [[0, 0, 0, 0, 0, 0, 0, 0]],
    },
    options: {
      showArea: true,
      height: '600',
      low: 0,
    },
  };
  chartKafInd: any = {
    type: 'Bar',
    data: {
      labels: [],
      series: [],
    },
    options: {
      showArea: true,
      height: '600',
      low: 0,
    },
  };
  chartKaf: Chart = {
    type: 'Line',
    data: {
      labels: environment.kafedra,
      series: [
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0,
        ],
      ],
    },
    options: {
      showArea: true,
      height: '600',
      width: '3000px',
      low: 0,
      axisX: {
        offset: 100,
      },
    },
  };
  constructor(private dataService: DataService) {
    // document.addEventListener('click', (e)=>{
    //   if (e.srcElement['innerText'] && e.srcElement['innerText'].length<100) {
    //      this.showKbi = false;
    //      setTimeout(()=>{
    //        this.showKafByIndex(e.srcElement['innerText']);
    //      }, 100)
    //   }
    // })
    this.tizim = dataService.tizim;
    this.getLabels();
    this.genTableSet();
  }
  isGradeEnough(wagerate, all){
    wagerate = parseFloat(wagerate);
    all = parseFloat(all);
    if (
      (wagerate === 1.5 && all < 25) ||
      (wagerate === 1.25 && all < 22.5) ||
      (wagerate === 1 && all < 20) ||
      (wagerate === 0.75 && all < 15) ||
      (wagerate === 0.5 && all < 10) ||
      (wagerate === 0.25 && all < 5)
    )return true;
    return false;
}
  getLabels() {
    this.dataService.field$.subscribe((fields) => {
      var labels = [];
      fields.forEach((field, idx, sss) => {
        labels.push(replaceAll(field.id, 'd', '.'));
        if (sss.length === idx + 1) {
          this.labels = labels;
          console.log('labels', this.labels);
        }
      });
    });
  }
  changeSelectedLabel(label) {
    this.selectedLabel = label;
    this.tizim = this.dataService.tizim;
    this.initialize();
    this.getLabels();
    this.genTableSet();
  }
  showKafByIndex(src) {
    this.dataService.field$.subscribe((fields) => {
      this.chartKafInd.data.labels = [];
      this.chartKafInd.data.series = [];
      var series = [];
      var labels = [];
      this.tmp.kafName = src;
      fields.forEach((field, idx, sss) => {
        this.chartKafInd.data.labels.push(replaceAll(field.id, 'd', '.'));
        labels.push(field.id);
        series.push(0);
        if (sss.length === idx + 1) {
          console.log(labels);
          this.chartKafInd.data.series.push(series);
          this.showKafInn(src, labels);
        }
      });
    });
  }
  showKafInn(src, labels) {
    this.dataService.pvoKaf$.subscribe((pvo: PvoKafInter[]) => {
      if (pvo.length) {
        var found = false;
        pvo.forEach((res, idxPvo, sss) => {
          if (res.kafed === src) {
            found = true;
            labels.forEach((labelIndex, idx) => {
              if (res[labelIndex]) {
                this.chartKafInd.data.series[0][idx] += res[labelIndex].grade;
              }
            });
          }
          if (sss.length === idxPvo + 1 && found) {
            this.showKbi = true;
          }
        });
      }
    });
  }
  genTableSet() {
    this.settings.columns['number'] = {
      title: '№',
      type: 'number',
      width: '60px',
      sort: true,
      sortDirection: 'asc',
    };
    this.settings.columns['name'] = { title: "To'liq ismi sharifi" };
    this.settings.columns['kafed'] = { title: 'Kafedra' };
    if (environment.otm === 'fjsti') {
      this.settings.columns['wagerate'] = { title: 'Stavka' };
    }
    this.dataService.field$.subscribe((fields) => {
      fields.forEach((field, idx, sss) => {
        if (field) {
          this.settings.columns[`title${idx}`] = {
            title: replaceAll(field.id, 'd', '.'),
          };
        }
        if (sss.length === idx + 1) {
          this.settings.columns['all'] = { title: 'umumiy' };
          this.dataService.pvoKaf$.subscribe((pvo: PvoKafInter[]) => {
            if (pvo.length) {
              this.getpvoKafLength(pvo, fields);
            }
          });
        }
      });
    });
  }
  getpvoKafLength(pvo: PvoKafInter[], fields) {
    var pvoKafLength = {};
    pvo.forEach((res, idxPvo, sss) => {
      if (res && res.kafed) {
        var resK = res.kafed.replace(/[ ,.]/g, '');
        pvoKafLength[`${resK}`] =
          (pvoKafLength[`${resK}`] ? pvoKafLength[`${resK}`] : 0) + 1;
      }
      if (sss.length === idxPvo + 1) {
        // this.getMaxCitiation(pvo, fields, pvoKafLength)
        // .then((res)=>{ if(res){this.genTableSource(pvo, fields, pvoKafLength);} });
        this.genTableSource(pvo, fields, pvoKafLength);
      }
    });
  }
  indexAppropriateGrade(indexNumber) {
    switch (indexNumber) {
      case '1':
        return 5.4;
      case '2':
        return 3.6;
      case '3':
        return 10.7;
      case '4':
        return 5.4;
      case '5':
        return 6.0;
      case '6':
        return 10.0;
      case '7':
        return 5.0;
      case '8':
        return 3.6;
      case '9':
        return 3.6;
      case '10':
        return 3.6;
      case '11':
        return 5.4;
      case '12':
        return 3.6;
      case '13':
        return 3.6;
      case '14':
        return 10.7;
      case '15':
        return 5.4;
      case '16':
        return 3.6;
      case '17':
        return 5.4;
      case '18':
        return 3.6;
      case '19':
        return 1.8;
      default:
        return 0;
    }
  }
  ascKafedraRating() {
    //------------------------------------------------------------------------
    // Step 1: Create an array of key, value, and title
    const combined2 = Object.entries(this.kafedra[0]).map(([key, value]) => ({
      key,
      value: parseFloat(value as string),
      title: this.kafedraSet.columns[key]?.title?.trim(),
    }));

    // Step 2: Sort the array in descending order
    const sorted2 = combined2.sort((a, b) => b.value - a.value);

    // Step 3: Rebuild this.kafedra[0] in new order
    this.kafedra[0] = {};
    sorted2.forEach((item) => {
      this.kafedra[0][item.key] = item.value.toFixed(3); // Keep string format like original
    });

    // Step 4: Rebuild this.kafedraSet.columns in new order
    const newColumns = {};
    sorted2.forEach((item) => {
      newColumns[item.key] = { title: item.title };
    });
    this.kafedraSet.columns = newColumns;
  }
  genTableSource(pvo: PvoKafInter[], fields, pvoKafLengthFir) {
    this.dataService.field$.subscribe((fields) => {
      // savesfsfor = 1.5 save for special formulas
      const tmpSource = [];
      var fakultet = {},
        kafedra = {},
        pvoKafLength = {},
        pvoFakLength = {};
      pvo.forEach((res, idxPvo, sss) => {
        if (res && res.kafed) {
          // console.log(res)
          if (
            !res['pvo_status'] ||
            (res['pvo_status'] && res['pvo_status'] === 'working')
          ) {
            var arr = {},
              sum = 0;
            arr['name'] =
              res.lname +
              ' ' +
              res.fname +
              ' ' +
              (res.patronymic ? res.patronymic : '');
            arr['number'] = idxPvo + 1;
            arr['kafed'] = res.kafed;
            arr['wagerate'] = res.wagerate;
            var resK = res.kafed.replace(/[ ,.]/g, '');
            var resF = res.fakul.replace(/[ ,.]/g, '');

            fields.forEach((field, idx, aaa) => {
              if (field) {
                if (environment.otm === 'fjsti') {
                  const calcGrade = Number(
                    (res[`${field.id}`]?.grade * field.coeff).toFixed(3)
                  );
                  const comparedGrade =
                    calcGrade > this.indexAppropriateGrade(field.id)
                      ? this.indexAppropriateGrade(field.id)
                      : calcGrade;
                  arr[`title${idx}`] = res[`${field.id}`] ? comparedGrade : 0;
                } else if (field.id === '1d5d2' && environment.otm === 'fstu') {
                  if (res[`${field.id}`]) {
                    const citiGrade = parseFloat(
                      (
                        ((res[`${field.id}`]
                          ? (res[`${field.id}`]?.total ?? 0).toFixed(3)
                          : 0) *
                          this.calCitiation1d5d2.maxGrade) /
                        (this.calCitiation1d5d2.current
                          ? this.calCitiation1d5d2.current
                          : 1)
                      ).toFixed(3)
                    );
                    arr[`title${idx}`] =
                      citiGrade > this.calCitiation1d5d2.maxGrade
                        ? this.calCitiation1d5d2.maxGrade
                        : citiGrade;
                  }
                } else if (field.id !== '1d5') {
                  arr[`title${idx}`] = res[`${field.id}`]
                    ? (res[`${field.id}`].grade * field.coeff).toFixed(3)
                    : 0;
                  if (field.id === '3d2') {
                    arr[`title${idx}`] = (
                      (arr[`title${idx}`] * 100) /
                      this.dataService.chanAbFormulas['3d2'].grastud
                    ).toFixed(3);
                  }
                } else {
                  // if(this.calCitiation.current < res[`${field.id}`].total){this.calCitiation.current = res[`${field.id}`].total; this.calCitiation.title = ('title' + idx)}
                  const citiGrade = parseFloat(
                    (
                      ((res[`${field.id}`]
                        ? res[`${field.id}`].total.toFixed(3)
                        : 0) *
                        this.calCitiation.maxGrade) /
                      (this.calCitiation.current
                        ? this.calCitiation.current
                        : 1)
                    ).toFixed(3)
                  );
                  arr[`title${idx}`] =
                    citiGrade > this.calCitiation.maxGrade
                      ? this.calCitiation.maxGrade
                      : citiGrade;

                  // arr[`title${idx}`] = res[`${field.id}`]?(((res[`${field.id}`].total * field.coeff / (environment.otm === 'fdu' ? 4 : 1))/(pvoKafLengthFir[res.kafed.replace(/[ ,.]/g, "")])).toFixed(3)):0;
                }
                sum += parseFloat(arr[`title${idx}`]);
              }
              if (aaa.length === idx + 1) {
                arr['all'] = sum.toFixed(3);
                tmpSource.push(arr);
                var trK = res.kafed.replace(/[ ,.]/g, '');
                var trF = res.fakul.replace(/[ ,.]/g, '');
                if (!isNaN(sum)) {
                  let sumCulc = environment.otm !== 'fjsti' ? sum : !this.isGradeEnough(res.wagerate, sum) ? sum : 0;
                  fakultet[`${trF}`] =
                    (fakultet[`${trF}`] ? fakultet[`${trF}`] : 0) + sumCulc;
                  kafedra[`${trK}`] =
                    (kafedra[`${trK}`] ? kafedra[`${trK}`] : 0) + sumCulc;
                }
                if(environment.otm === 'fjsti'){
                  let pvoToCount = !this.isGradeEnough(res.wagerate, sum) ? 1 : 0;
                  pvoKafLength[`${resK}`] =
                  (pvoKafLength[`${resK}`] ? pvoKafLength[`${resK}`] : 1) + pvoToCount;
                  pvoFakLength[`${resF}`] =
                    (pvoFakLength[`${resF}`] ? pvoFakLength[`${resF}`] : 1) + pvoToCount;
                }else{
                  pvoKafLength[`${resK}`] =
                  (pvoKafLength[`${resK}`] ? pvoKafLength[`${resK}`] : 1) + 1;
                  pvoFakLength[`${resF}`] =
                    (pvoFakLength[`${resF}`] ? pvoFakLength[`${resF}`] : 1) + 1;
                }
              }
            });
          }
        }
        if (sss.length === idxPvo + 1) {
          this.source.load(tmpSource);
          this.dataService.kafedraDialogData.source = JSON.parse(
            JSON.stringify(this.source)
          );
          var arrKaf = {},
            arrKafChart = [],
            arrFak = {},
            arrFakChart = [],
            tizimCount = 0;
          this.tizim.forEach((tiz, idxKaf, sssKaf) => {
            tiz.kafedralar.forEach((t) => {
              this.kafedraSet.columns[`title${tizimCount}`] = { title: t };
              let pvoKafLengthDivide = 1;
              const pvoKafLengthDynamic = this.dataService.areas?.find(
                (a) => a.name.replace(/[ ,.]/g, '') === t.replace(/[ ,.]/g, '')
              );
              if (pvoKafLengthDynamic) {
                pvoKafLengthDivide = pvoKafLengthDynamic.numOfEmployees
                  ? pvoKafLengthDynamic.numOfEmployees
                  : 1;
              } else {
                pvoKafLengthDivide = pvoKafLength[`${t.replace(/[ ,.]/g, '')}`]
                  ? pvoKafLength[`${t.replace(/[ ,.]/g, '')}`] - 1
                  : 1;
              }
              // console.log(pvoKafLengthStatic, t)
              arrKaf[`title${tizimCount}`] = (
                (kafedra[`${t.replace(/[ ,.]/g, '')}`]
                  ? kafedra[`${t.replace(/[ ,.]/g, '')}`]
                  : 0) / pvoKafLengthDivide
              ).toFixed(3);
              arrKafChart.push(arrKaf[`title${tizimCount}`]);
              tizimCount++;
            });
            this.fakultetSet.columns[`title${idxKaf}`] = {
              title: tiz.fakultet,
            };
            let pvoFakLengthDivide = this.dataService.areas?.reduce(
              (acc, a) => {
                if (
                  a.departmentName.replace(/[ ,.]/g, '') ===
                  tiz.fakultet.replace(/[ ,.]/g, '')
                ) {
                  acc = acc + (a.numOfEmployees ?? 1);
                }
                return acc;
              },
              0
            );
            if (!pvoFakLengthDivide) {
              pvoFakLengthDivide = pvoFakLength[
                `${tiz.fakultet.replace(/[ ,.]/g, '')}`
              ]
                ? pvoFakLength[`${tiz.fakultet.replace(/[ ,.]/g, '')}`] - 1
                : 1;
            }
            arrFak[`title${idxKaf}`] = (
              (fakultet[`${tiz.fakultet.replace(/[ ,.]/g, '')}`]
                ? fakultet[`${tiz.fakultet.replace(/[ ,.]/g, '')}`]
                : 0) / pvoFakLengthDivide
            ).toFixed(3);
            arrFakChart.push(arrFak[`title${idxKaf}`]);
            if (sssKaf.length === idxKaf + 1) {
              this.kafedra.push(arrKaf);
              this.fakultet.push(arrFak);
              this.chartFakul.data.series = [arrFakChart];
              this.chartKaf.data.series = [arrKafChart];
              this.dataService.rating$.next({
                chartFakul: this.chartFakul,
                chartKaf: this.chartKaf,
                kafedraSet: this.kafedraSet,
                kafedra: this.kafedra,
                fakultetSet: this.fakultetSet,
                fakultet: this.fakultet,
                settings: this.settings,
                source: this.source,
              });
            }
          });
          // console.log('calCitiation', this.calCitiation)
          // this.source.map(pvo=> { if( pvo && pvo[this.calCitiation.title]){ pvo[this.calCitiation.title] = ((parseFloat(pvo[this.calCitiation.title]) * 9)/ (this.calCitiation.current ? this.calCitiation.current : 1)).toFixed(3);
          //                         pvo['all'] = (parseFloat(pvo['all']) +  parseFloat(pvo[this.calCitiation.title])).toFixed(3); }});
          this.tmp.tableLoading = false;
        }
      });
      this.ascKafedraRating();
      // if (environment.otm === 'fjsti') {
      const combinedFak = (this.chartFakul.data.labels as any)?.map(
        (label, index) => ({
          label,
          value: parseFloat(this.chartFakul.data.series[0][index]),
        })
      );
      const sortedFak = combinedFak.sort((a, b) => b.value - a.value);
      this.chartFakul.data = {
        labels: sortedFak.map((item) => item.label),
        series: [sortedFak.map((item) => item.value)],
      };
      const combined = (this.chartKaf.data.labels as any)?.map(
        (label, index) => ({
          label,
          value: parseFloat(this.chartKaf.data.series[0][index]),
        })
      );
      const sorted = combined.sort((a, b) => b.value - a.value);
      this.chartKaf.data = {
        labels: sorted.map((item) => item.label),
        series: [sorted.map((item) => item.value)],
      };
      if (this.source && this.source['data'].length > 0) {
        this.source['data'].sort((a, b) => {
          const aVal = a && a.all ? parseInt(a.all, 10) : 0;
          const bVal = b && b.all ? parseInt(b.all, 10) : 0;
          return bVal - aVal;
        });

        // Re-number the rows in ascending order (1, 2, 3, ...)
        for (let i = 0; i < this.source['data'].length; i++) {
          this.source['data'][i].number = i + 1;
        }
        this.source.refresh();
      }
      // }
    });
  }

  fileName = 'ExcelSheet.xlsx';
  exportexcel(id) {
    /* table id is passed over here */
    this.tmp.tableLoading = true;
    if (id === 'excelTableFakultet') {
      this.fakultetSet.pager.display = false;
    }
    if (id === 'excelTableKafedra') {
      this.kafedraSet.pager.display = false;
    }
    if (id === 'excelTablePvo') {
      this.settings.pager.display = false;
    }
    setTimeout(() => {
      this.tmp.tableLoading = false;
      setTimeout(() => {
        // this.excelService.exportAsExcelFile(document.getElementById('excelTable').children[0]);
        // console.log('element', element)
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
          document.getElementById(`${id}`).children[0]
        );

        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        XLSX.writeFile(wb, this.fileName);
      }, 1000);
    }, 1000);
  }
  ngOnInit() {}
  initialize() {
    this.tmp = {
      tableLoading: true,
      kafName: '',
    };
    this.calCitiation = {
      current: 100,
      // title: ''
    };

    this.field = '';
    this.pvoKaf = [];
    this.kafedra = [];
    this.fakultet = [];
    this.showKbi = false;

    this.kafedraSet = {
      hideSubHeader: true,
      pager: {
        display: true,
      },
      actions: {
        add: false,
        edit: false,
        delete: false,
        position: 'none',
      },
      columns: {},
    };
    this.fakultetSet = {
      hideSubHeader: true,
      pager: {
        display: true,
      },
      actions: {
        add: false,
        edit: false,
        delete: false,
        position: 'none',
      },
      columns: {},
    };
    this.settings = {
      pager: {
        display: true,
      },
      actions: {
        add: false,
        edit: false,
        delete: false,
        position: 'none',
      },
      rowClassFunction: (row) => {
        if (environment.otm === 'fjsti') {
          let { wagerate, all } = row.data;
          wagerate = parseFloat(wagerate);
          all = parseFloat(all);
          if (
            (wagerate === 1.5 && all < 25) ||
            (wagerate === 1.25 && all < 22.5) ||
            (wagerate === 1 && all < 20) ||
            (wagerate === 0.75 && all < 15) ||
            (wagerate === 0.5 && all < 10) ||
            (wagerate === 0.25 && all < 5)
          ) {
            return 'red-row';
          }
          return '';
        }
      },
      columns: {},
    };
    this.source = new LocalDataSource();
    this.labels = [];
    this.chartFakul = {
      type: 'Line',
      data: {
        labels: environment.fakultet,
        series: [[0, 0, 0, 0, 0, 0, 0, 0]],
      },
      options: {
        showArea: true,
        height: '600',
        low: 0,
      },
    };
    this.chartKafInd = {
      type: 'Bar',
      data: {
        labels: [],
        series: [],
      },
      options: {
        showArea: true,
        height: '600',
        low: 0,
      },
    };
    this.chartKaf = {
      type: 'Line',
      data: {
        labels: environment.kafedra,
        series: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0,
          ],
        ],
      },
      options: {
        showArea: true,
        height: '600',
        width: '3000px',
        low: 0,
        axisX: {
          offset: 100,
        },
      },
    };
  }
}
function replaceAll(str, from, to) {
  var n = '';
  if (str) {
    for (let g of str) {
      if (g === from) {
        g = to;
      }
      n += g;
    }
  }
  return n;
}
